export default __webpack_public_path__ + "static/media/DSC40006.24bacf83.jpg";